export default __webpack_public_path__ + "line-chart-dark.6abbed93.svg";